module.exports = __webpack_public_path__ + "images/liinilaevad/routes/TAL-AEG-TAL@2x.png";